import { post } from '@/utils/network/axios-helper';
import type { IParamsType } from '@/utils/ctype';
import type { IReadingAIChatRecord, ISaveListeningAIChatRecord, IWritingAIContent} from './type';

export const saveListeningAIChatRecord = (params: ISaveListeningAIChatRecord) => {
  return post<{id: number;}>('/api/simulate/listening-save-ai-helper', params);
};

export const saveReadingAIChatRecord = (params: ISaveListeningAIChatRecord) => {
  return post<{id: number;}>('/api/simulate/reading-save-ai-helper', params);
};

export const fetchListeningAIHistory = (params: IParamsType & {id: number;}) => {
  return post<{list: ISaveListeningAIChatRecord[];}>('/api/simulate/listening-get-ai-helper-list', params);
};

export const fetchReadingAIHistory = (params: IParamsType & {id: number;}) => {
  return post<{list: IReadingAIChatRecord[];}>('/api/simulate/reading-get-ai-helper-list', params);
};

export const fetchWritingAnalysis = (params: IParamsType) => {
  return post<IWritingAIContent>('/api/simulate/get-writing-analysis', params);
};

